'use client';

import Script from 'next/script';
import React, { FC } from 'react';
import {parse} from 'node-html-parser'

type T_Props = {
   dHtml: string
}

const DomParser = ({dHtml} : T_Props) => {
   // const parser = new DOMParser();

   const beforeParser = (htmlStr : string) => {
      htmlStr = htmlStr.replace(/&lt;/g , "<");    
      htmlStr = htmlStr.replace(/&gt;/g , ">");    
      htmlStr = htmlStr.replace(/&quot;/g , "\"");  
      htmlStr = htmlStr.replace(/&#39;/g , "\'");  
      htmlStr = htmlStr.replace(/&amp;/g , "&");
      return htmlStr;
   }


   // convert html string into DOM
   const document = parse(dHtml).querySelector('code'); 
   // const document = parser.parseFromString(dHtml, "text/html"); 
   console.log('code it', document?.innerHTML, typeof(document?.innerHTML))
   // return document.querySelector('code');
   return (
      <div data-testid="DomParser" dangerouslySetInnerHTML={{__html: parse(beforeParser( document?.innerHTML || "")) }}></div>
   )
};

export default DomParser;
